import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '100%',
        flexShrink: 0,
        textTransform: 'capitalize',
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
});

class CompanyPanels extends React.Component {
  state = {
      expanded: null,
  };

  handleChange = panel => (event, expanded) => {
      this.setState({
          expanded: expanded ? panel : false,
      });
  };

  render() {
      const { classes, terms } = this.props;
      const { expanded } = this.state;

      return (
          <div className={classes.root}>
              <ExpansionPanel expanded={expanded === 'panel134'} onChange={this.handleChange('panel134')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography
                          className={classes.heading}
                      >
                          In Business Since 2013
                      </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                      <Typography className="specsText">
                          <p>

                              Solvana&apos;s co-founders, Ric Breines, and Michael Ruecktenwald each have over a decade of experience in PV solar, over 50-years of combined experience in construction, and hundreds of satisfied customers. It&apos;s safe to say that Solvana can handle any project we come across and make your customer experience hassle-free. Solvana will install your  {terms.systemSize / 1000} kW solar-generating system before you know it, and you will not regret choosing us to develop your project.

                          </p>

                      </Typography>
                  </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel expanded={expanded === 'panel2'} onChange={this.handleChange('panel2')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography className={classes.heading}>
                          Solvana&apos;s Proposal App Saves You Both Time & Money
                      </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                      <Typography className="specsText">
                          <p>
                              Thanks to Solvana&apos;s advanced proposal generating app, which was custom-designed and coded by Solvana&apos;s IT team, we can reduce our soft costs significantly and pass those savings on to you, our customers. When you choose Solvana, you save both time and money.
                          </p>

                      </Typography>
                  </ExpansionPanelDetails>
              </ExpansionPanel>
              {terms.resiToggle ?
                  <ExpansionPanel expanded={expanded === 'panel4'} onChange={this.handleChange('panel4')}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>The Best Equipment & Sleekest Installations</Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <Typography className="specsText">
                              <p>
                                  Solvana can design, engineer, obtain and install the most modern PV solar-generating equipment and components, including:
                              </p>
                              <ul>
                                  <li>all-black racking;</li>
                                  <li>all-black solar modules;</li>
                                  <li>module-level production monitoring;</li>
                                  <li>rapid shutdown with a temperature sensor and emergency autodial;</li>
                                  <li>most efficient, highest-rated, and technologically advanced inverters;</li>
                                  <li>most advanced, safest, and reliable energy storage systems (batteries).</li>
                              </ul>
                              <p>
                                  Throughout the year, Solvana’s PV solar experts stay up to date on the latest products and technology by attending training & tradeshows and staying in communication with manufacturers and suppliers. Solvana researches all the bankable manufacturers in the PV solar sector to find the right materials for your PV solar-generating system, so you do not have to.
                              </p>

                          </Typography>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  : null }
              {terms.includeESS ? null :
              <ExpansionPanel expanded={expanded === 'panel5'} onChange={this.handleChange('panel5')}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography className={classes.heading}>We are Certified Dealers & Installers for Many Energy Storage System Solutions</Typography>
                  </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                      <Typography className="specsText">
                              <p>
                                  Energy Storage Solutions (ESS or batteries) are already a significant part of the renewable energy landscape. Solvana’s solar-generating systems can be optimized for energy storage, saving you the time and money it takes to remove and replace inadequate solar equipment and components installed by other solar-generating system developers. You may add batteries now or in the future. Either way, Solvana designs the right solution for you.
                              </p>
                          </Typography>
                  </ExpansionPanelDetails>
                  </ExpansionPanel>
              }
              <ExpansionPanel expanded={expanded === 'panel6'} onChange={this.handleChange('panel6')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography className={classes.heading}>100% Customer Satisfaction is our Goal</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                      <Typography className="specsText">
                          <p>
                              {terms.firstName}, it is our goal to make you 100% satisfied. It&#39;s not about being perfect; it&#39;s about being there to fix any challenges in a timely and professional manner, before, during, and most importantly, after the installation. Solvana prides itself on being meticulous, organized, and efficient. We put a tremendous amount of effort into your project before the installation phase. By physically measuring and surveying the roof, conduit runs, equipment location, and testing a variety of design and engineering options, by the time we arrive for the actual installation, the rest of the project is easy-peasy. However, we are human and realize things do not always go according to plan. And that&#39;s ok. We fix what needs to be fixed, stand by our word, and complete everything before handing the project over to you. Solvana also includes a 10-year Workmanship Warranty for your peace-of-mind, which is double what is required by law in many states. And to ensure material warranties are reliable, Solvana chooses bankable vendors to provide the equipment and components for your project.
                          </p>
                      </Typography>
                  </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel expanded={expanded === 'panel7'} onChange={this.handleChange('panel7')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography className={classes.heading}>We are Certified Dealers & Installers for Many Energy Storage System Solutions</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                      <Typography className="specsText">
                          <p>
                              Solvana is a certified dealer and installer for most leading energy storage system companies, including Fortress™ Power, Generac™, LG Chem™, Panasonic™. Solvana follows strict safety and quality control standards and practices utilizing extensive checklists to ensure voltage measurements and storage conditions conform to manufacturer’s specifications. And, by going above-and-beyond before your installation even begins, Solvana ensures your energy storage system will be reliable and adhere to manufacturer warranty requirements.
                          </p>
                      </Typography>
                  </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel expanded={expanded === 'panel8'} onChange={this.handleChange('panel8')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography className={classes.heading}>Turnkey Service</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                      <Typography className="specsText">
                          <p>
                              Our Turnkey service includes everything from signing your permitting and incentive applications to coordinating the final meter swap with your utility. And, we are with you well after we energize your solar generating system with the security and peace of mind you get from our 10-year labor warranty. We are the experts, with over 5 decades of experience engineering, permitting, and installing construction projects. Solvana has you covered, and we will provide you with the customer service you deserve.
                          </p>
                      </Typography>
                  </ExpansionPanelDetails>
              </ExpansionPanel>

          </div>
      );
  }
}

CompanyPanels.propTypes = {
    classes: PropTypes.object.isRequired,
    terms: PropTypes.object.isRequired,
};

export default withStyles(styles)(CompanyPanels);



// WEBPACK FOOTER //
// ./src/containers/Home/Company/CompanyPanels.js